import type { OccupationSkillAssessments } from 'bundles/account-profile/common/types';
import { getOccupationIdOrName } from 'bundles/account-profile/common/utils';

/**
 *
 * @param occupationSkillsAssessments - a list of occupation skills assessments from the backend.
 * @returns true if there is at least one assessment with a result that has a numerical score and false otherwise
 */
export function doesAnyAssessmentHaveResults(
  occupationSkillsAssessments: OccupationSkillAssessments | undefined | null
) {
  if (!occupationSkillsAssessments) return false;

  return !!occupationSkillsAssessments?.some((assessment) =>
    assessment.testResults.some((testResult) => testResult.result?.score === 0 || !!testResult.result?.score)
  );
}

/**
 *
 * @param occupationSkillsAssessments - a list of occupation skills assessments from the backend.
 * @param occupationId - the occupation id to use to find potential assessment results
 * @returns true if the provided occupation id maps to an assessment with a score and false otherwise
 */
export function doesOccupationHaveAssessmentResults(
  occupationSkillsAssessments: OccupationSkillAssessments | undefined,
  occupationId: string
) {
  const assessmentForOccupation = occupationSkillsAssessments?.find((assessment) => {
    return occupationId === getOccupationIdOrName(assessment.occupation);
  });

  return !!assessmentForOccupation?.testResults.some(
    (testResult) => testResult.result?.score === 0 || !!testResult.result?.score
  );
}
